import React from 'react';
import { Box, Inscription, WarningCard, WarningIcon } from '@common-fe/common-fe';

const AccountVerificationPendingMessage = () => (
  <Box margin={{ top: 'spacing12' }}>
    <WarningCard
      containerProps={{
        pad: { vertical: 'spacing16', horizontal: 'spacing24' },
      }}
    >
      <Box direction="row" align="center">
        <WarningIcon />
        <Inscription color="textBody" weight="bold" lineHeight="20px" margin={{ left: 'spacing8' }}>
          You cannot use this payment method yet
        </Inscription>
      </Box>
      <Inscription color="textBody" lineHeight="20px" margin={{ top: 'spacing8' }}>
        This payment method is still pending verification. You'll be able to use it as soon as your
        bank account is confirmed.
      </Inscription>
    </WarningCard>
  </Box>
);

export default AccountVerificationPendingMessage;
